import './ParameterList.scss';
import { ParameterModel } from 'types/trackmanParameters';

type ParameterListProps = {
  parameters: ParameterModel[];
  selectedParameterId: string | undefined;
  onParameterSelected: (parameterId: string) => void;
};

export const ParameterList = ({ parameters, selectedParameterId, onParameterSelected }: ParameterListProps) => (
  <div className='parameters-list'>
    {parameters.map((parameter) => (
      <div
        className={selectedParameterId === parameter.id ? 'parameter-entry parameter-entry__active' : 'parameter-entry'}
        key={parameter.id}
        onClick={() => onParameterSelected(parameter.id)}
      >
        {parameter.title}
      </div>
    ))}
  </div>
);

export default ParameterList;
